import React, { createContext, useContext, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const Ctx = createContext({ require: () => true });
export const useAuthGate = () => useContext(Ctx);

const DEFAULT_MSG = "Create a free account to message sellers, save listings and connect with the community.";

export function AuthGateProvider({ children }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState(DEFAULT_MSG);

  // Returns true if the user is signed in; otherwise opens the prompt and returns false.
  const require = useCallback((message) => {
    if (user) return true;
    setMsg(message || DEFAULT_MSG);
    setOpen(true);
    return false;
  }, [user]);

  return (
    <Ctx.Provider value={{ require }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="auth-prompt">
          <DialogHeader>
            <DialogTitle className="font-display text-xl">Join Mtaa to continue</DialogTitle>
            <DialogDescription>{msg}</DialogDescription>
          </DialogHeader>
          <div className="mt-2 flex flex-col gap-2">
            <Button onClick={() => { setOpen(false); nav("/register"); }} data-testid="auth-prompt-join">Join Mtaa</Button>
            <Button variant="outline" onClick={() => { setOpen(false); nav("/login"); }} data-testid="auth-prompt-signin">Sign in</Button>
            <button onClick={() => setOpen(false)} className="mt-1 text-sm text-muted-foreground hover:text-foreground" data-testid="auth-prompt-close">Keep browsing</button>
          </div>
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
}
